import { ChartDataPoint, ChartSeries, PieChartStoreData, QueryMode } from '../types'
import { PieChartView } from './PieChartView'
import { BarLineChart } from './BarLineChart'

interface PerformanceChartProps {
  data: ChartDataPoint[]
  series: ChartSeries[]
  colors: (index: number) => string
  chartType: 'bar' | 'line' | 'pie'
  pieChartData?: PieChartStoreData[]
  pieChartLoading?: boolean
  queryMode: QueryMode
  t: (key: string, options?: Record<string, unknown>) => string
  totalResultCount: number
  selectedResultIds: string[]
}

const PerformanceChart = ({
  data,
  series,
  colors,
  chartType,
  pieChartData = [],
  pieChartLoading = false,
  queryMode,
  t,
  totalResultCount,
  selectedResultIds,
}: PerformanceChartProps) => {
  if (chartType === 'pie') {
    return (
      <PieChartView
        pieChartData={pieChartData}
        pieChartLoading={pieChartLoading}
        queryMode={queryMode}
      />
    )
  }

  return (
    <BarLineChart
      data={data}
      series={series}
      colors={colors}
      chartType={chartType}
      queryMode={queryMode}
      totalResultCount={totalResultCount}
      selectedResultIds={selectedResultIds}
    />
  )
}

export { PerformanceChart }
